import {REGION_SHIPPING_MAP} from '../constants/countries';
import {StoreRegionData} from './storeGeoLocator';

type Products = 'orca-core' | 'orca-tablet-mount-core-bundle' | undefined;

type Shipping = string | undefined;

type InstallationGuidance = string | undefined;

export type ConfiguratorOptions = {
  product: Products;
  shipping: Shipping;
  installationGuidance: InstallationGuidance;
  email: string | undefined;
};

export const DEFAULT_CONFIGURATOR_OPTIONS: ConfiguratorOptions = {
  product: 'orca-tablet-mount-core-bundle',
  shipping: undefined,
  installationGuidance: undefined,
  email: undefined,
};

export enum ConfiguratorV2ProductIds {
  'orca-charging-mount-surface-1' = 'orca-charging-mount-surface-1',
  'orca-charging-mount-top-1' = 'orca-charging-mount-top-1',
  'orca-display-2' = 'orca-display-2',
  'orca-core-1' = 'orca-core-1',
  'orca-subscription-premium-1' = 'orca-subscription-premium-1',
}

export type ProductName =
  | 'Surface Mount'
  | 'Top Mount'
  | 'Display 2'
  | 'Core 2'
  | 'Premium Subscription';

export type ConfiguratorV2ProductConfiguration = {
  id: ConfiguratorV2ProductIds;
  count: number;
};

export type ConfiguratorV2Options = {
  email: string | undefined;
  productConfiguration: ConfiguratorV2ProductConfiguration[];
};

export const DEFAULT_V2_CONFIGURATOR_OPTIONS: ConfiguratorV2Options = {
  email: undefined,
  productConfiguration: [],
};

const getDatePlusDays = (days: number) => {
  const date = new Date();
  return new Date(date.setDate(date.getDate() + days));
};

const capitalize = (word: string) => {
  const lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
};

const getDayAndMonthFromDate = (date: Date) =>
  `${date.getDate()} ${capitalize(
    date.toLocaleString('default', {month: 'long'})
  )}`;

export const getMinEstimatedShippingDate = (
  storeCountry: StoreRegionData[]
) => {
  if (!storeCountry) return null;

  const days = REGION_SHIPPING_MAP[storeCountry['0'].region].min;
  const newDate = getDatePlusDays(days);
  return getDayAndMonthFromDate(newDate);
};

export const getMaxEstimatedShippingDate = (
  storeCountry: StoreRegionData[]
) => {
  if (!storeCountry) return null;

  const days = REGION_SHIPPING_MAP[storeCountry['0'].region].max;
  const newDate = getDatePlusDays(days);
  return getDayAndMonthFromDate(newDate);
};

export function getConfiguratorProductName(
  productId: ConfiguratorV2ProductIds
): ProductName {
  const productNames: Record<ConfiguratorV2ProductIds, ProductName> = {
    [ConfiguratorV2ProductIds['orca-charging-mount-surface-1']]:
      'Surface Mount',
    [ConfiguratorV2ProductIds['orca-charging-mount-top-1']]: 'Top Mount',
    [ConfiguratorV2ProductIds['orca-display-2']]: 'Display 2',
    [ConfiguratorV2ProductIds['orca-core-1']]: 'Core 2',
    [ConfiguratorV2ProductIds['orca-subscription-premium-1']]:
      'Premium Subscription',
  };

  return productNames[productId];
}
